document.addEventListener('DOMContentLoaded', function () {
  // Menu toggle
  const toggleBtn = document.querySelector('.mobileMenu-toggle');
  if (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      document.body.classList.add('menu_open');
    });
  }

  // Event delegation for cart icon
  document.addEventListener('click', function (e) {
    if (e.target.closest('.header__icon--cart')) {
      e.preventDefault();
      document.body.classList.add('cart-sidebar-show');
      console.log('cart-sidebar-show class added');
    }

    if (e.target.closest('.halo-sidebar-close') || e.target.closest('.background-overlay')) {
      document.body.classList.remove('menu_open');
      document.body.classList.remove('cart-sidebar-show');
      console.log('Sidebar closed');
    }
  });
});
